import { render, staticRenderFns } from "./hotelloadingcomp.vue?vue&type=template&id=608e51bd"
import script from "./hotelloadingcomp.vue?vue&type=script&lang=js"
export * from "./hotelloadingcomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports